import React from 'react';
import load from '../Assets/loader.gif'
const Loader = () => {
  return (
    <div className="flex justify-center items-center w-full h-screen fixed inset-0 bg-[#000] z-50 bg-opacity-50">
      <img src={load} alt="Loader" className=' w-40 h-auto' />
    </div>
  );
};

export default Loader;
